module.exports = __webpack_public_path__ + "img/logo-private-transparent.d889819b.png";